"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Base_1 = __importDefault(require("./Base"));
var firebase_1 = require("./firebase");
var Dashboards = /** @class */ (function (_super) {
    __extends(Dashboards, _super);
    function Dashboards(orgId) {
        var _this = _super.call(this, "") || this;
        _this.getIdsForUser = function (uid) {
            return _this.getByPath("/users_mapping/" + _this.orgId + "/dashboards/" + uid);
        };
        _this.getConfig = function (dashboardId) {
            return _this.getByPath("/dashboards_config/" + _this.orgId + "/" + dashboardId);
        };
        _this.getAuthRoles = function (uid, dashboardId) {
            return _this.getByPath("/users_mapping/" + _this.orgId + "/dashboards/" + uid + "/" + dashboardId);
        };
        _this.requestListMembers = function (orgId, uid, dashboardId) {
            var request = {
                audit: {
                    createdBy: uid
                },
                dashboardId: dashboardId
            };
            return _this.create("/apis/" + orgId + "/" + uid + "/list_dashboard_members", request);
        };
        _this.addUserToResource = function (orgId, uid, dashboardId, userId) {
            var request = {
                audit: {
                    createdBy: uid
                },
                dashboardId: dashboardId,
                userId: userId
            };
            return _this.create("/apis/" + orgId + "/" + uid + "/add_user_to_dashboard", request);
        };
        _this.getLayout = function (dashboardId) {
            return _this.getByPath("/dashboards/" + _this.orgId + "/" + dashboardId + "/layout");
        };
        _this.updateLayout = function (dashboardId, layout) {
            return _this.update("/dashboards/" + _this.orgId + "/" + dashboardId + "/layout", layout);
        };
        _this.getWidgets = function (dashboardId) {
            return _this.getByPath("/dashboards/" + _this.orgId + "/" + dashboardId + "/widgets");
        };
        _this.createWidget = function (dashboardId, widgetObject) {
            widgetObject.request.requestedAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
            return _this.create("/dashboards/" + _this.orgId + "/" + dashboardId + "/widgets", widgetObject);
        };
        _this.orgId = orgId;
        return _this;
    }
    Dashboards.prototype.deleteUserToResource = function (orgId, authUserId, dashboardId, userId) {
        var request = {
            audit: {
                createdBy: authUserId
            },
            dashboardId: dashboardId,
            userId: userId
        };
        return this.create("/apis/" + orgId + "/" + authUserId + "/deactivate_dashboard_user", request);
    };
    ;
    Dashboards.prototype.changePermissionToResource = function (orgId, authUserId, dashboardId, userId, newAccountType) {
        var request = {
            audit: {
                createdBy: authUserId
            },
            dashboardId: dashboardId,
            userId: userId,
            newAccountType: newAccountType
        };
        return this.create("/apis/" + orgId + "/" + authUserId + "/change_dashboard_user_account_type", request);
    };
    ;
    Dashboards.prototype.deleteResource = function (authUserId, resourceId) {
        var request = {
            audit: {
                createdBy: authUserId
            },
            dashboardId: resourceId
        };
        return this.create("/apis/" + this.orgId + "/" + authUserId + "/delete_dashboard", request);
    };
    ;
    Dashboards.prototype.updateName = function (resourceId, config) {
        config.audit.updatedAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
        return this.update("/dashboards_config/" + this.orgId + "/" + resourceId, config);
    };
    return Dashboards;
}(Base_1.default));
///apis/{orgId}/{callerId}/add_user_to_dashboard/{requestId}
exports.default = Dashboards;
//# sourceMappingURL=Dashboards.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/data/Dashboards.js
// module id = 233
// module chunks = 8